import { PageWrapper } from '@layout/page_wrapper';
import { MpoConfigTable } from '@widgets/mpo_config_table';

export const MpoConfig = () => {
  return (
    <PageWrapper>
      <MpoConfigTable />
    </PageWrapper>
  );
};

export default MpoConfig;
